export default __webpack_public_path__ + "static/media/sasprinter-icon.53ab1509.jpg";